var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Carousel',{staticClass:"container",attrs:{"autoplay":"","autoplay-speed":15000,"radius-dot":"","loop":""}},_vm._l((_vm.carouselItems),function(p){return _c('CarouselItem',{key:p},[_c('div',{staticClass:"carousel-item",style:(`background:no-repeat url(${p})`)})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }